module.exports = __webpack_public_path__ + "img/7.38e52066.png";